import { initialState } from 'src/contexts/settings/settings-context';
import { therapyPlanningAction } from '../../actions/constant';

const { GET_PLAN_OF_CARE_FAILURE, GET_PLAN_OF_CARE_SUCCESS, GET_PLAN_OF_CARE_LOADING } =
  therapyPlanningAction;

const intitialstate: object = {
  isError: false,
  errorMessage: '',
  response: null,
  loading: false,
};

export const getPlanOfCareReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case GET_PLAN_OF_CARE_SUCCESS: {
      return {
        ...state,
        response: action.payload,
        isError: false,
        errorMessage: '',
        loading: false,
      };
    }

    case GET_PLAN_OF_CARE_FAILURE:
      return {
        ...state,
        isError: true,
        errorMessage: action.payload,
        response: null,
        loading: false,
      };
    case GET_PLAN_OF_CARE_LOADING:
      return {
        ...initialState,
        loading: true,
      };
    default:
      return state;
  }
};
